import React from 'react';
import OverviewMap from "./overviewmap/OverviewMap";
import {googleMapURL} from "../../constants/googleMaps";
import UnitList from "./unitlist/UnitList";
import RecordingsList from "./RecordingsList";
import {connect} from "react-redux";
import {LANDING} from "../../constants/routes";

/**
 * The dashboard component.
 */
const Dashboard = ({units}) => {
    return (
        <div className="container mt-4">
            {
                units && Object.keys(units).length > 0
                    ? (
                        <div>
                            <OverviewMap
                                googleMapURL={googleMapURL}
                                loadingElement={<div style={{height: `400px`}} />}
                                containerElement={<div style={{height: '400px', minHeight: 399}} />}
                                mapElement={<div style={{height: `400px`}} />}
                            />
                            <hr/>
                            <div className="row">
                                <div className="col-lg-8 col-md-6 col-sm-12 col-xs-12 mt-4">
                                    <h4>Notifications</h4>
                                    <p>You have no new notifications.</p>
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 mt-4">
                                    <h4>Your Vehicles</h4>
                                    <UnitList/>
                                </div>
                                <div className="col-12 mt-4">
                                    <h4>Recent Recordings</h4>
                                    <RecordingsList/>
                                </div>
                            </div>
                        </div>
                    )
                    : <div className="text-center">You have no vehicles. Get your <a href={LANDING}>AutoI</a> today!</div>
            }
        </div>
    );
};

/**
 * Map Redux {@param state} to component props
 */
const mapStateToProps = (state) => ({
    units: state.unitsState.units
});

export default connect(mapStateToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/dashboard/Dashboard.jsx